module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Se turneringar","track":"Browse tournaments"}}